import { useDispatch, useSelector } from "react-redux";
import Col from "../element/col";
import Row from "../element/row";
import Title from "./common.title";
import Container from "../element/container";
import Image from "../element/image";
import Icon from "../element/icon";
import formatNumber from "../../helpers/format.number";
import { useNavigate } from "react-router-dom";
import Quantity from "../element/quantity";
import { Skeleton } from "primereact/skeleton";
import Button from "../element/button";
import { closeCartDropdown } from "../../redux/reducer/common.reducer";

export default function CommonSummary({ loading, data, type }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = useSelector((state) => state.cart);

  const handleNavigate = () => {
    navigate("/cart");
    dispatch(closeCartDropdown());
  };

  const summaryList = [
    { label: "subtotal" },
    { label: "shipping" },
    { label: "tax" },
  ];

  const eastMalaysiaList = ["Sabah", "Sarawak", "Labuan"];

  // const today = new Date();
  // today.setHours(0, 0, 0, 0);

  // const promoEnd = new Date(today);
  // promoEnd.setDate(promoEnd.getDate() + 1);
  // promoEnd.setHours(17, 0, 0, 0);

  const now = new Date();

  const start =
    process.env.REACT_APP_ENV === "development"
      ? new Date("2025-05-09T00:00:00")
      : new Date("2025-05-11T11:00:00");
  const end =
    process.env.REACT_APP_ENV === "development"
      ? new Date("2025-05-09T18:05:59")
      : new Date("2025-05-14T23:59:59");

  const isFreeDelivery = now >= start && now <= end;

  const emDeliveryFee = isFreeDelivery ? 0 : 25;
  const wmDeliveryFee = isFreeDelivery ? 0 : 15;

  return (
    <>
      {data?.total < 150 && !isFreeDelivery && (
        <Col className="common-free-shipping">
          <Row className="_row free-shipping">
            <Icon icon="hugeicons:shopping-basket-remove-03" />
            <p>
              You're just{" "}
              <span>RM{formatNumber(150 - parseFloat(data?.total))}</span> away
              from enjoying free shipping!
            </p>
          </Row>
          <Row className="_row shipping-progress">
            <Col
              className="_col active-progress"
              style={{ width: `${(parseFloat(data?.total) / 150) * 100}%` }}
            />
          </Row>
        </Col>
      )}
      <Col className={`common-summary --${type ?? ""}`}>
        {type !== "dropdown" && (
          <>
            <h3>Order Summary</h3>
            <Col className="summary-list">
              {summaryList.map((summary, summaryIndex) => (
                <Row
                  className="w-100 h-flex justify-between"
                  key={summaryIndex}
                >
                  <h6>{summary.label}</h6>
                  {loading ? (
                    summary.label === "subtotal" ? (
                      <Skeleton
                        width="60px"
                        height="20px"
                        borderRadius="0"
                        className="_gray"
                      />
                    ) : (
                      <p>-</p>
                    )
                  ) : (
                    <p>
                      {summary.label === "subtotal" ? (
                        type === "order" ? (
                          data["subtotal"]
                        ) : (
                          formatNumber(data["total"], "decimal")
                        )
                      ) : summary.label === "shipping" ? (
                        data["delivery_fee"] ? (
                          formatNumber(data["delivery_fee"], "decimal")
                        ) : state && type !== "order" ? (
                          data?.total >= 150 || isFreeDelivery ? (
                            "FREE"
                          ) : (
                            formatNumber(
                              data?.total >= 150
                                ? 0
                                : eastMalaysiaList?.length > 0 &&
                                  eastMalaysiaList.includes(state)
                                ? emDeliveryFee
                                : wmDeliveryFee,
                              "decimal"
                            )
                          )
                        ) : type !== "order" ? (
                          <span>Enter Shipping Address</span>
                        ) : (
                          "-"
                        )
                      ) : (
                        "-"
                      )}
                    </p>
                  )}
                </Row>
              ))}
            </Col>
          </>
        )}
        <Col className="w-100">
          <Row className="w-100 h-flex justify-between items-start flex-nowrap gap-3">
            <Row
              className={`h-flex ${
                type === "dropdown"
                  ? "flex-col items-start"
                  : "w-100 justify-between items-end"
              } gap-2`}
            >
              {type !== "dropdown" && <h6>Total</h6>}
              {loading ? (
                <Skeleton
                  width="100px"
                  height="26px"
                  borderRadius="0"
                  className="_gray"
                />
              ) : (
                <h4>
                  RM{" "}
                  {type === "order"
                    ? data?.total_price
                    : formatNumber(
                        parseFloat(
                          data?.total +
                            (data?.total >= 150
                              ? 0
                              : eastMalaysiaList?.length > 0 &&
                                eastMalaysiaList.includes(state)
                              ? emDeliveryFee
                              : wmDeliveryFee)
                        ),
                        "decimal"
                      )}
                </h4>
              )}
              {type === "dropdown" && (
                <h6>
                  Estimated total
                  <span> (excl. tax and shipping)</span>
                </h6>
              )}
            </Row>
            {type === "dropdown" && (
              <Button
                className="_button checkout"
                onClick={() => handleNavigate()}
              >
                Checkout
              </Button>
            )}
            {/* {type === "dropdown" && (
            <p>* Shipping & taxes will be calculated at checkout</p>
          )} */}
          </Row>
        </Col>
      </Col>
    </>
  );
}
